import {printoutPalette} from "../../core/printoutPalette";

export const fieldBlockSx = {
    "& .printout-field-block, & .printout-rendered-field": {
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "1.5mm",
        minWidth: 0,
        width: "100%",
        // Keep the writing area and its label on the same printed page.
        "@media print": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
        },
    },
    "& .printout-field-input, & .printout-rendered-field-input": {
        backgroundColor: "var(--printout-field-fill-color, transparent)",
        boxSizing: "border-box",
        height: "var(--printout-field-height, 10mm)",
        printColorAdjust: "exact",
        WebkitPrintColorAdjust: "exact",
        width: "100%",
    },
    '& .printout-field-block[data-printout-field-line-style="underline"] .printout-field-input, & .printout-rendered-field[data-printout-field-line-style="underline"] .printout-rendered-field-input': {
        borderBottom: "1px solid var(--printout-field-line-color, currentColor)",
    },
    '& .printout-field-block[data-printout-field-line-style="box"] .printout-field-input, & .printout-rendered-field[data-printout-field-line-style="box"] .printout-rendered-field-input': {
        border: "1px solid var(--printout-field-line-color, currentColor)",
    },
    "& .printout-field-label, & .printout-rendered-field-label": {
        color: printoutPalette.mutedText,
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.25,
        minHeight: 15,
    },
    "& .printout-field-label p, & .printout-rendered-field-label p": {
        m: 0,
        maxWidth: "none",
    },
};
